import React from "react";
import { useSelector } from "react-redux";
import PostLandingpage from "./PostLandingpage";
import { Box } from "@mui/material";
import HelperScreen from "../../common/ToolTip/HelperScreen";
import { useTranslation } from "react-i18next"; //locale

const Post = () => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const userData = useSelector((state) => state?.profile?.profileData);
  return (
    <Box width={"100%"} margin={"auto"}>
      {!userData?.data?.tooltipPostScreenWeb && (
        <HelperScreen
          title={"How Post works"}
          updateKey={"tooltip_post_screen_web"}
          contactSections={[
            { heading: appContent?.KEY379, content: [appContent?.KEY380] },
            { heading: appContent?.KEY381, content: [appContent?.KEY382] },
            { heading: appContent?.KEY383, content: [appContent?.KEY384] },
            { heading: appContent?.KEY385, content: [appContent?.KEY386] },
            { heading: appContent?.KEY387, content: [appContent?.KEY388] },
          ]}
        />
      )}
      <PostLandingpage />
    </Box>
  );
};

export default Post;
